module.exports = __webpack_public_path__ + "static/media/company_profile.8a809d26.svg";